import { useDispatch } from "react-redux";
import { bindActionCreators, createAction } from "@reduxjs/toolkit";

import { IEntity } from "@/shared/types";

import { ActionType } from "./types/actionType";
import {
  TableRowPayload,
  ControlButtonPayload,
  ControlTogglePayload,
  TableActionButtonPayload,
} from "./types/types";

const tableRowClicked = createAction<TableRowPayload<IEntity>>(
  ActionType.TABLE_ROW_CLICKED
);

const tableActionButtonClicked = createAction<
  TableActionButtonPayload<IEntity>
>(ActionType.TABLE_ACTION_BUTTON_CLICKED);

const controlToggleSwitched = createAction<ControlTogglePayload>(
  ActionType.CONTROL_TOGGLE_SWITCHED
);

const controlCreateButtonClicked = createAction<ControlButtonPayload>(
  ActionType.CONTROL_CREATE_BUTTON_CLICKED
);

const paidOrderButtonClicked = createAction(
  ActionType.PAID_ORDER_BUTTON_CLICKED
);

const completeOrderButtonClicked = createAction(
  ActionType.COMPLETE_ORDER_BUTTON_CLICKED
);

const shippingOrderButtonClicked = createAction(
  ActionType.SHIPPING_ORDER_BUTTON_CLICKED
);

const deleteOrderButtonClicked = createAction(
  ActionType.DELETE_ORDER_BUTTON_CLICKED
);

const cancelOrderrButtonClicked = createAction(
  ActionType.CANCEL_ORDER_BUTTON_CLICKED
);

const cancelRequestButtonClicked = createAction(
  ActionType.CANCEL_REQUEST_BUTTON_CLICKED
);

const acceptRequestButtonClicked = createAction(
  ActionType.ACCEPT_REQUEST_BUTTON_CLICKED
);

const controlImportButtonClicked = createAction(
  ActionType.CONTROL_IMPORT_BUTTON_CLICKED
);

const controlSetPriceButtonClicked = createAction(
  ActionType.CONTROL_SET_PRICE_BUTTON_CLICKED
);

export const useActions = () => {
  const dispatch = useDispatch();
  return bindActionCreators(
    {
      tableRowClicked,
      tableActionButtonClicked,
      controlToggleSwitched,
      controlCreateButtonClicked,
      controlImportButtonClicked,
      controlSetPriceButtonClicked,
      paidOrderButtonClicked,
      deleteOrderButtonClicked,
      completeOrderButtonClicked,
      shippingOrderButtonClicked,
      cancelOrderrButtonClicked,
      cancelRequestButtonClicked,
      acceptRequestButtonClicked,
    },
    dispatch
  );
};

export const sagaActions = {
  tableRowClicked,
  tableActionButtonClicked,
  controlToggleSwitched,
  controlCreateButtonClicked,
  controlImportButtonClicked,
  controlSetPriceButtonClicked,
  paidOrderButtonClicked,
  deleteOrderButtonClicked,
  completeOrderButtonClicked,
  shippingOrderButtonClicked,
  cancelOrderrButtonClicked,
  cancelRequestButtonClicked,
  acceptRequestButtonClicked,
};
